import { render, staticRenderFns } from "./SelectComp.vue?vue&type=template&id=ea39dee0&"
import script from "./SelectComp.vue?vue&type=script&lang=js&"
export * from "./SelectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports